
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MoqupLots extends Vue {

  private headers = [
    {value: "name", text: "Nom"},
    {value: "floor", text: "Étage"},
    {value: "actions", text: ""},
  ];
  private items = [
    {
      name: "LT CLIM T04-134",
      floor: "4",
    },
    {
      name: "VDI A08-314",
      floor: "4",
    },
    {
      name: "SBR A09-354",
      floor: "4",
    },
    {
      name: "BUREAU C08-004",
      floor: "4",
    },
    {
      name: "BUREAU A13-001",
      floor: "4",
    },
  ];
}
